import { useState, useEffect } from "react";
import { useSelector } from "react-redux";

const LANGUAGE_MAP = {
  EN: "english",
  HI: "hindi",
};

/**
 * Custom hook that fetches FAQ data from the new REST API.
 * Returns [faqList, loading, error]
 * Each item in faqList: { id, question, steps: [{ content, image }] }
 */
const useFaqApiFetch = () => {
  const [data, setData] = useState(null);
  const [fetching, setFetching] = useState(true);
  const [error, setError] = useState(false);

  const faqLangObj = useSelector((state) => state.faqLanguageReducer);
  const { languageCode } = faqLangObj;

  useEffect(() => {
    const language = LANGUAGE_MAP[languageCode] || "english";
    const baseUrl = process.env.REACT_APP_BASE_URL || "http://192.168.0.145:8000";
    const url = `${baseUrl}/media/faq/?language=${language}`;

    setFetching(true);
    setError(false);

    fetch(url)
      .then((res) => {
        if (!res.ok) throw new Error(`HTTP error: ${res.status}`);
        return res.json();
      })
      .then((json) => {
        if (json?.status && Array.isArray(json?.data)) {
          setData(json.data);
        } else {
          setData([]);
        }
        setFetching(false);
      })
      .catch((err) => {
        console.error("FAQ API fetch error:", err);
        setError(true);
        setData([]);
        setFetching(false);
      });
  }, [languageCode]);

  return [data, fetching, error];
};

export default useFaqApiFetch;
